export const translations = {
  it: {
    global: {
      ok: "OK",
      cancel: "Annulla",
      save: "Salva",
      error: "Errore",
      success: "Successo",
      loading: "Caricamento in corso...",
      energy: "Energia",
      premiumPro: "VinoLogic PRO",
      premiumUltimate: "VinoLogic ULTIMATE"
    },
    alerts: {
      missingDataTitle: "Aggiornamento Dati",
      serverOverload: "I server IA sono temporaneamente sovraccarichi. L'energia ti è stata rimborsata."
    },
    login: {
      subtitle: "La tua cantina personale in tasca",
      tabs: {
        login: "Accedi",
        register: "Registrati tramite e-mail"
      },
      registration: {
        nameLabel: "Come ti chiami?",
        namePlaceholder: "Il tuo nome (o nickname)",
        langCountryLabel: "Lingua e Nazione"
      },
      fields: {
        emailLabel: "Indirizzo Email",
        emailPlaceholder: "es. mario@email.com",
        passwordLabel: "Password",
        passwordPlaceholderLogin: "Inserisci password",
        passwordPlaceholderRegister: "Crea una password sicura",
        passwordHint: "* Minimo 6 caratteri"
      },
      compliance: {
        adultDeclaration: "Dichiaro di essere maggiorenne",
        termsReadAndAccept: "Ho letto e accetto i ",
        termsOfService: "Termini di Servizio",
        andThe: " e la ",
        privacyPolicy: "Privacy Policy"
      },
      buttons: {
        loginAction: "Accedi alla Cantina",
        registerAction: "Crea Account",
        forgotPassword: "Hai dimenticato la password?",
        dismiss: "Ho capito",
        cancel: "Annulla",
        // INTEGRAZIONE CHIAVI SOCIAL ED EMAIL ADATTIVE
        continueWithGoogle: "Continua con Google",
        continueWithApple: "Continua con Apple",
        orWithEmail: "oppure con e-mail"
      },
      biometricSelector: {
        title: "Scegli Account",
        subtitle: "Con quale account vuoi accedere?",
        prompt: "Accedi come"
      },
      alerts: {
        missingCredentialsTitle: "Attenzione",
        missingCredentialsMsg: "Inserisci email e password per accedere.",
        verifyEmailTitle: "Verifica Email",
        verifyEmailMsg: "Devi prima verificare la tua email. Controlla la posta (anche nello Spam).",
        loginErrorTitle: "Errore Accesso",
        loginErrorMsg: "Credenziali errate o account inesistente.",
        biometricSetupTitle: "Attenzione",
        biometricSetupMsg: "Devi effettuare l'accesso con la password almeno una volta per abilitare la biometria.",
        vaultErrorTitle: "Errore",
        vaultErrorMsg: "Impossibile leggere la cassaforte delle credenziali.",
        biometricFailTitle: "Errore",
        biometricFailMsg: "Accesso biometrico fallito o annullato.",
        missingFieldsTitle: "Attenzione",
        missingFieldsMsg: "Nome, Email e Password sono obbligatori.",
        shortPasswordTitle: "Attenzione",
        shortPasswordMsg: "La password deve avere almeno 6 caratteri.",
        adultRequiredTitle: "Età Richiesta",
        adultRequiredMsg: "Devi confermare di essere maggiorenne per procedere con la registrazione.",
        termsRequiredTitle: "Accettazione Richiesta",
        termsRequiredMsg: "Devi leggere e accettare i Termini di Servizio e la Privacy Policy per registrarti.",
        registerSuccessTitle: "Benvenuto nel Caveau! 🎁",
        registerSuccessMsg: "Account creato con successo! Ti abbiamo regalato 5 Punti Energia per iniziare a esplorare l'Intelligenza Artificiale.\n\nClicca sul link che ti abbiamo inviato via email per attivare l'account.",
        emailInUseTitle: "Attenzione",
        emailInUseMsg: "Esiste già un account registrato con questa email.",
        resetEmailSentTitle: "Email Inviata",
        resetEmailSentMsg: "Controlla la tua casella di posta per ripristinare la password.",
        resetErrorTitle: "Errore",
        resetErrorMsg: "Utente non trovato o errore di sistema.",
        ageInfoTitle: "Requisito Età Minima",
        ageInfoMsg: "VinoLogic è un'applicazione dedicata alla classificazione e al mondo del vino.\n\nIn conformità con le normative legali vigenti relative agli alcolici e alle policy degli Store digitali, è obbligatorio aver compiuto la maggiore età (18+ anni) per poter creare un account.\n\nDichiarando il falso, l'utente si assume la piena responsabilità civile e penale.",
        linkErrorMsg: "Impossibile aprire il link.",
        webBiometricMsg: "L'accesso biometrico è disponibile solo su Smartphone."
      }
    },
    profile: {
      title: "Impostazioni",
      accountVerified: "Account Verificato",
      upgrade: {
        planMonthly: "Il tuo piano: Per mese",
        planAnnual: "Il tuo piano: Per anno",
        desc: "Vuoi rimuovere per sempre i rinnovi automatici o risparmiare a lungo termine? Passa al piano Caveau. Il costo verrà calcolato in automatico dallo store.",
        button: "Esplora l'Upgrade a Vita"
      },
      sections: {
        personalData: "Dati Personali",
        security: "Sicurezza",
        legal: "Informazioni Legali"
      },
      fields: {
        nameLabel: "Nome o Nickname",
        namePlaceholder: "Il tuo nome",
        langCountryLabel: "Lingua e Nazione",
        passwordLabel: "Nuova Password (minimo 6 caratteri)",
        passwordPlaceholder: "Inserisci nuova password",
        confirmPasswordLabel: "Conferma Nuova Password",
        confirmPasswordPlaceholder: "Ripeti nuova password"
      },
      buttons: {
        saveProfile: "Salva Dati Personali",
        changePassword: "Cambia Password",
        terms: "Termini di Servizio",
        privacy: "Privacy Policy",
        cookies: "Gestisci Preferenze Cookie",
        deleteAccount: "Elimina Account e Dati"
      },
      dangerZoneDesc: "L'eliminazione rimuoverà definitivamente la tua cantina e i tuoi dati nel rispetto del GDPR. L'action è irreversibile.",
      deleteModal: {
        title: "Ci lasci già?",
        message: "Ci dispiace vederti andare via! La tua cantina virtuale andrà perduta per sempre. 🍷\n\nIn ottemperanza al GDPR (Azione irreversibile), confermando eliminerai tutti i tuoi dati, i vini e il tuo account dai nostri server.\n\nInserisci la tua password per confermare l'identità:",
        passwordPlaceholder: "La tua password",
        stayButton: "Ho cambiato idea, resto!",
        confirmButton: "Elimina tutto definitivamente"
      },
      alerts: {
        saveSuccessTitle: "Profilo Aggiornato",
        saveSuccessMsg: "Dati salvati con successo.",
        saveErrorTitle: "Errore",
        saveErrorMsg: "Impossibile salvare i dati, riprova più tardi.",
        emptyFieldsTitle: "Errore",
        emptyFieldsMsg: "Compila tutti i campi.",
        shortPasswordTitle: "Errore",
        shortPasswordMsg: "La password deve avere almeno 6 caratteri.",
        mismatchPasswordTitle: "Errore",
        mismatchPasswordMsg: "Le password non coincidono.",
        passwordSuccessTitle: "Successo",
        passwordSuccessMsg: "Password aggiornata correttamente!",
        passwordErrorTitle: "Errore",
        passwordErrorMsg: "Impossibile aggiornare la password al momento.",
        deleteWarningTitle: "Attenzione",
        deleteWarningMsg: "Inserisci la tua password per confermare l'eliminazione.",
        deleteWrongPasswordTitle: "Errore",
        deleteWrongPasswordMsg: "La password inserita non è corretta. Riprova.",
        deleteErrorTitle: "Errore",
        deleteErrorMsg: "Impossibile completare l'operazione. Contatta il supporto.",
        linkErrorTitle: "Errore",
        linkErrorMsg: "Impossibile aprire il link nel browser."
      }
    },
    home: {
      header: {
        welcome: "Bentornato,",
        loadingName: "Caricamento..."
      },
      hero: {
        title: "Il Tuo Sommelier",
        subtitle: "Chiedi l'abbinamento perfetto",
        toggleEat: "Cosa mangi?",
        toggleDrink: "Cosa bevi?",
        placeholderFood: "Bistecca, pesce...",
        placeholderWine: "Barolo, Chianti..."
      },
      results: {
        fromCellar: "Dalla Cantina",
        toBuy: "Da Comprare",
        noMatchTitle: "Nessun abbinamento ideale",
        bestChoice: "Scelta Ideale",
        locateAction: "Localizza",
        openSheet: "Apri Scheda",
        alternative: "L'Alternativa (Stile Diverso)",
        expertAdvice: "Il consiglio dell'esperto:",
        perfectDishes: "Piatti perfetti per questo vino:"
      },
      sections: {
        management: "Gestione Cantina"
      },
      grid: {
        addWineTitle: "Aggiungi Referenza",
        addWineSub: "Scansiona o inserisci manualmente",
        cellar3dTitle: "La Mia Cantina 3D",
        cellar3dSub: "Disposizione fisica",
        myWinesTitle: "I Miei Vini",
        myWinesSubCalc: "Calcolo...",
        myWinesSubLabels: "etichette",
        statsTitle: "Analisi",
        statsSub: "Valore e statistiche",
        mapTitle: "Le Tue Vigne",
        mapSub: "Mappa geografica"
      },
      buttons: {
        logoutConfirmTitle: "Disconnessione",
        logoutConfirmMsg: "Sei sicuro di voler uscire dal tuo account VinoLogic?",
        cancel: "Annulla",
        exit: "Esci",
        dismiss: "Ho capito"
      },
      alerts: {
        logoutErrorMsg: "Impossibile disconnettersi. Riprova.",
        adSuccessTitle: "Energia Ricaricata",
        adSuccessMsg: "Hai ottenuto +5⚡.\nOra puoi chiedere l'abbinamento al Sommelier!"
      }
    },
    addWine: {
      title: "Aggiungi Referenza",
      camera: {
        instructions: "Inquadra l'etichetta nel box",
        take: "Scatta",
        shootPhoto: "Scatta Foto",
        smartCam: "Fotocamera smart",
        fromGallery: "Dalla Galleria",
        uploadImg: "Carica un'immagine",
        permissionDeniedTitle: "Permesso Negato",
        permissionDeniedMsg: "Devi concedere l'accesso alla fotocamera per usare questa funzione.",
        shootErrorTitle: "Errore Scatto",
        shootErrorMsg: "Non è stato possibile acquisire l'immagine.",
        galleryErrorTitle: "Errore",
        galleryErrorMsg: "Impossibile caricare l'immagine dalla galleria."
      },
      loading: {
        title: "Analisi etichetta in corso...",
        sub: "Il Sommelier sta studiando la bottiglia."
      },
      form: {
        successBanner: "Dati estratti! Revisiona la scheda.",
        bottles: "Bottiglie",
        type: "Tipologia",
        types: {
          rosso: "Rosso",
          bianco: "Bianco",
          bollicine: "Bollicine",
          rosato: "Rosato",
          dolce: "Dolce"
        },
        labels: {
          name: "Nome del Vino",
          annata: "Annata",
          vitigno: "Vitigno",
          regione: "Regione",
          gradazione: "Gradazione",
          affinamento: "Affinamento",
          temperatura: "Temperatura",
          drinkingWindow: "Forchetta Consumo",
          recalcWindow: "Ricalcolo Forchetta...",
          pairingTags: "Abbinamenti"
        },
        placeholders: {
          vintageInput: "Es: 2019"
        }
      },
      aiActions: {
        marketAnalysis: "Analisi di mercato...",
        estimateValue: "Stima valore bottiglia (1⚡)",
        estimation: "Stima",
        sommelierNote: "Nota del Sommelier",
        generateReview: "Genera recensione Sommelier (1⚡)"
      },
      buttons: {
        saveAndPlace: "Salva e posiziona in cantina",
        saveOnly: "Salva tra i miei vini - potrai posizionare in seguito",
        cancelOp: "Annulla operazione",
        vintageNotFound: "Annata non trovata",
        vintageModalMsg: "Il Sommelier non è riuscito a dedurre l'annata di questa bottiglia. Se conosci l'anno, inseriscilo hier sotto.",
        unknownVintage: "Non nota (S.A.)",
        saveYear: "Salva Anno",
        editTitle: "Modifica",
        valueInfoTitle: "Informazioni sul Valore",
        valueInfoMsg: "Il valore mostrato è una stima puramente indicativa calcolata dall'Intelligenza Artificiale basandosi sul prezzo medio storico di mercato della bottiglia.\n\nNon costituisce una quotazione finanziaria accurata."
      },
      alerts: {
        adCompleteTitle: "Ricarica Completata",
        adCompleteMsg: "+5 Punti Energia aggiunti con successo! Ora puoi analizzare l'etichetta.",
        invalidImgTitle: "Immagine non valida",
        invalidImgMsg: "Nessuna bottiglia riconoscibile. Riprova con un'altra foto. L'energia non ti è stata scalata.",
        technicalErrorTitle: "Errore Técnico",
        technicalErrorMsg: "I server IA sono temporaneamente sovraccarichi. L'energia ti è stata rimborsata. Compila i dati a mano o riprova tra poco.",
        nameRequiredTitle: "Attenzione",
        nameRequiredMsg: "Il nome del vino è obbligatorio.",
        saveSuccessTitle: "Successo!",
        saveSuccessMsg: "Vino salvato tra i tuoi vini. Potrai posizionarlo in cantina in seguito.",
        saveCloudErrorTitle: "Errore",
        saveCloudErrorMsg: "Impossibile salvare il vino nel cloud."
      }
    },
    catalog: {
      title: "La Tua Cantina",
      loading: "Caricamento cantina...",
      tabs: {
        present: "Presenti",
        past: "Passate"
      },
      filters: {
        readyToDrink: "🍷 Pronto da bere",
        all: "Tutti"
      },
      empty: {
        title: "Nessuna referenza",
        text: "Non ci sono vini che corrispondono ai tuoi filtri in questa sezione."
      },
      buttons: {
        add: "Aggiungi"
      }
    },
    details: {
      title: "Dettagli Vino",
      statusPast: "Terminata",
      statusPresent: "in Inventario",
      valuation: "La tua valutazione:",
      alignBanner: {
        desc: "Questa bottiglia è stata inserita in una versione precedente. Tocca qui per allinearla con le informazioni aggiuntive.",
        action: "Allinea Scheda (1⚡)"
      },
      translateBanner: {
        title: "Traduzione Scheda",
        desc: "I testi descrittivi di questo vino sono salvati in un'altra lingua. Rigenera e adatta la scheda nella tua lingua attuale.",
        action: "Aggiorna in Italiano (1⚡)"
      },
      valueBox: {
        marketAnalysis: "Analisi di mercato in corso...",
        revealValue: "Rivela valore stimato (1⚡)",
        estimation: "Stima"
      },
      placement: {
        title: "Collocazione in Cantina",
        bottleSingle: "Bottiglia",
        bottlePlural: "Bottiglie",
        show3d: "Mostra nel Caveau 3D"
      },
      sections: {
        theWine: "Il Vino",
        pairings: "Abbinamenti Consigliati",
        sommelierIa: "Dettagli del Sommelier (IA)",
        techSheet: "Scheda Tecnica"
      },
      sommelierPrompt: {
        text: "Scopri la storia, le caratteristiche uniche e i segreti di questo vino con il nostro Master Sommelier virtuale.",
        action: "Generare recensione (1⚡)"
      },
      modals: {
        addBottlesTitle: "Aggiungi Bottiglie",
        addBottlesMsg: "Quante nuove bottiglie di questo vino vuoi inserire in inventario?",
        saveOnlyList: "Salva solo nell'elenco vini",
        placeNowCaveau: "Colloca ora nel Caveau",
        unplacedInventory: "Dall'inventario (Deposito)",
        from3dCellar: "Dalla Cantina 3D",
        goAction: "Vai ⚡",
        stappataTitle: "Stappa Bottiglia",
        stappataMsg: "Da dove hai preso la bottiglia che stai per consumare?",
        insertVintageTitle: "Inserisci l'Annata",
        insertVintageMsg: "Per poter calcolare la corretta forchetta di consumo e il valore di mercato, inserisci l'anno della bottiglia.",
        confirmBtn: "Conferma",
        editDataTitle: "Modifica Dati",
        storageLoc: "Luogo di conservazione (Opzionale)",
        recalcAction: "Ricalcola ⚡",
        recalcHint: "Hai modificato l'annata. È consigliato ricalcolare la forchetta.",
        recalcLoading: "Ricalcolo finestra...",
        vintageLabelHint: "ex. 2019 or S.A.",
        locationLabelHint: "Scaffale, Cantinetta...",
        pairingLabelHint: "Abbinamenti (separati da virgola)",
        descLabel: "Descrizione Breve",
        saveChanges: "Salva Modifiche"
      },
      alerts: {
        bottleFinishedTitle: "Bottiglia Terminata",
        bottleFinishedMsg: "Hai consumato l'ultima bottiglia. Il vino è stato spostato nelle referenze passate.",
        cinCinTitle: "Cin cin! 🍷",
        cinCinMsg: "Bottiglia stappata dal deposito. Inventario aggiornato con successo.",
        addedTitle: "Aggiunte",
        addedMsg: "bottiglie aggiunte all'elenco.",
        deleteConfirmTitle: "Elimina Definitivamente",
        deleteConfirmMsg: "Sei sicuro di voler cancellare questa bottiglia? L'operazione non può essere annullata.",
        deleteActionBtn: "Elimina",
        emptyVintageTitle: "Attenzione",
        emptyVintageMsg: "Inserisci un'annata valida per calcolare la forchetta.",
        recalcErrorMsg: "Impossibile ricalcolare la forchetta al momento.",
        saveEditSuccessMsg: "I dettagli del vino sono stati aggiornati correttamente.",
        saveEditErrorMsg: "Impossibile salvare le modifiche. Riprova."
      }
    },
    map: {
      title: "Le Tue Vigne",
      dashboard: {
        terroirTitle: "Il Terroir",
        terroirSub: "Tocca i calici per scoprire come il clima influenza i tuoi vini.",
        findVinesTitle: "Trova Vigne",
        findVinesSub: "Localizza {count} nuove bottiglie (1⚡)",
        cellarMappedTitle: "Cantina Mappata",
        cellarMappedSub: "Tutte le tue bottiglie sono state localizzate."
      },
      sheet: {
        territorialAnalysis: "Analisi Territoriale",
        expertReport: "Il Report dell'Esperto",
        recalcAudit: "Ricalcola Audit del Terroir (1⚡)",
        generateAudit: "Genera Audit (1⚡)",
        firstAuditPrompt: "Genera il tuo primo Audit per scoprire l'impatto del clima sui tuoi vini.",
        myWinesHere: "I miei vini qui ({count}):",
        unspecifiedRegion: "Non Specificata",
        notSpecified: "Non Specificata"
      },
      alerts: {
        adCompleteTitle: "Ricarica Effettuata",
        adCompleteMsg: "+5 Punti Energia aggiunti! Ora puoi analizzare il terroir.",
        locateSuccessTitle: "Localizzazione Terminata",
        locateSuccessMsg: "Le tue bottiglie sono state posizionate con successo sulla mappa.",
        terroirErrorTitle: "Server Occupati",
        terroirErrorMsg: "Impossibile esplorare il terroir al momento. La tua energia è stata rimborsata.",
        geoErrorTitle: "Sommelier Occupato",
        geoErrorMsg: "Impossibile completare la geolocalizzazione ora. La tua energia è stata rimborsata."
      }
    },
    stats: {
      title: "Analisi & Statistice",
      loading: "Caricamento delle statistiche...",
      hero: {
        subtitle: "Valore Stimato della Collezione",
        bottles: "Bottiglie nella Cantina",
        maturation: "Stato di maturazione",
        ready: "🍷 Pronte da stappare",
        aging: "⏳ In affinamento / Riposo"
      },
      suggestions: {
        title: "Quale vino mi consigli di stappare?",
        sub: "Il Sommelier seleziona le migliori bottiglie da aprire in questo momento, nel cuore del loro apogeo.",
        ask: "Chiedi al Sommelier (1⚡)",
        option: "Opzione",
        openSheet: "Apri scheda",
        more: "Vedi altre proposte (1⚡)",
        emptyTitle: "Cantina Vuota",
        emptyMsg: "Aggiungi qualche bottiglia prima di chiedere un consiglio!"
      },
      audit: {
        title: "Composizione della cantina",
        outdated: "Hai aggiunto o rimosso bottiglie. Ricalcola per aggiornare i grafici.",
        translate: "L'analisi attuale è salvata in un'altra lingua. Aggiorna per tradurla.",
        expert: "Il Rapport dell'Esperto:",
        recalc: "Ricalcola Audit (1⚡)",
        emptyTitle: "Classificazione Enologica",
        emptyText: "Genera il tuo primo Audit per catalogare i tuoi vini come un vero Sommelier stellato.",
        generate: "Genera Audit (1⚡)",
        successTitle: "Audit Terminato",
        successMsg: "I grafici e il report sono stati aggiornati con successo!"
      }
    },
    paywall: {
      title: "Sblocca il potenziale della tua Cantina",
      sub: "Scopri i piani che stiamo preparando per te.",
      testBannerText: "Questa versione è ancora in fase di test. I piani premium non sono al momento attivi. Con il rilascio della prima versione definitiva, verrà data la possibilità di abbonarsi per supportare il progetto!",
      loadingPreview: "Caricamento anteprima offerte...",
      disclaimerText: "Acquisti disabilitati durante la fase di test.",
      soonAvailable: "Presto disponibile",
      notActiveTest: "Non ancora attivo nella versione test",
      restoreNotNeeded: "Ripristino acquisti attualmente non necessario",
      plans: {
        monthly: {
          title: "Mensile",
          period: "/mese",
          catchphrase: "Offrici un calice!",
          badge: null,
          f1: "Zero pubblicità",
          f2: "IA Illimitata",
          f3: "Supporto al team"
        },
        annual: {
          title: "Annuale",
          period: "/anno",
          catchphrase: "Scelta smart: -16%",
          badge: "Consigliato",
          f1: "Tutti i vantaggi Mensili",
          f2: "Sconto 16%",
          f3: "2 Mesi gratis"
        },
        lifetime: {
          title: "Caveau",
          period: "Una tantum",
          catchphrase: "Tuo per sempre.",
          badge: "Miglior Affare",
          f1: "Tutti i vantaggi Annuali",
          f2: "Nessun rinnovo",
          f3: "Sblocco a vita"
        }
      }
    },
    caveau: {
      title: "Cantina 3D",
      localizedWine: "Vino Localizzato",
      activeSpaceFor: "Spazio attivo per:",
      aiRecommendation: "Consiglio Sommelier IA (1⚡)",
      deselect: "Deseleziona",
      searchResultsFor: "Risultati per",
      clearSearch: "Pulisci ✖",
      loadingCellar: "Allestimento Cantina...",
      loadingCellarSub: "Il primo caricamento richiede qualche secondo.",
      emptyCellars: "Non hai ancora nessuna cantinetta.",
      buildFirst: "Costruisci la prima",
      expand: {
        row: "Piano",
        col: "Colonna",
        depth: "Fila Dietro"
      },
      buttons: {
        place: "Colloca",
        search: "Cerca",
        edit: "Modifica",
        dismantle: "Smantella"
      },
      modals: {
        inventoryToPlace: "Inventario da Collocare",
        inventoryEmpty: "Tutte le tue bottiglie sono state riposte ordinatamente in cantina!",
        searchTitle: "Evidenziatore 3D",
        searchPlaceholder: "Inizia a scrivere (es. Barolo)...",
        searchSuggestionsLabel: "Suggerimenti (Costo 1⚡):",
        selectedBottle: "Bottiglia Selezionata",
        slotActionMsg: "Cosa vuoi fare con questo spazio?",
        consumeAction: "Stappa e consuma (1⚡)",
        returnToDeposit: "Rimetti in deposito (1⚡)",
        createCellarTitle: "Costruisci Cantinetta",
        cellarNameLabel: "Nome (Es: Frigo Taverna)",
        cellarNamePlaceholder: "Scrivi un nome...",
        cellarTempLabel: "Temperatura di Esercizio (°C)",
        cellarArrangementLabel: "Disposizione",
        arrangements: {
          horizontal: "Sdraiata",
          vertical: "In Piedi"
        },
        dimensions: {
          rows: "Righe",
          cols: "Colonne"
        },
        createBtn: "Crea",
        editCellarTitle: "Modifica Parametri Struttura",
        cellarIdentifierLabel: "Identificativo Cantina",
        bottleArrangementLabel: "Disposizione Bottiglie",
        editHint: "* Le dimensioni di piani e colonne sono espandibili direttamente tramite le frecce sullo schermo 3D.",
        closeBtn: "Chiudi"
      },
      alerts: {
        notEmptyTitle: "Struttura non vuota",
        notEmptyMsg: "Impossibile eliminare perché sono presenti bottiglie. Rimuovi prima le bottiglie dalla cantina per poterla eliminare.",
        deleteConfirmTitle: "Smantella Cantinetta",
        deleteConfirmMsg: "Confermi di voler distruggere la struttura vuota \"{name}\"?",
        noWineSelectedTitle: "Nessun vino",
        noWineSelectedMsg: "Seleziona prima un vino cliccando su 'Colloca', poi tocca uno spazio vuoto.",
        consumeSuccessTitle: "Cin cin! 🍷",
        consumeSuccessMsg: "Hai stappato {name}. È stato rimosso dalla cantina.",
        aiPlacementTitle: "Consiglio Sommelier IA ⚡",
        placeErrorMsg: "Impossibile posizionare la bottiglia.",
        updateErrorMsg: "Impossibile aggiornare la cantina.",
        updateDetailsErrorMsg: "Impossibile aggiornare i dettagli.",
        aiConnectionErrorMsg: "Impossibile connettersi all'assistente virtuale. L'energia ti è stata riaccreditata."
      }
    },
    components: {
      cookieConsent: {
        title: "La tua Privacy è importante",
        desc: "Utilizziamo cookie tecnici strettamente necessari per il funzionamento dell'app (es. per mantenerti collegato). Inoltre, previo tuo consenso, vorremmo utilizzare cookie statistici e di profilazione per migliorare l'app e mostrarti contenuti personalizzati.",
        acceptAll: "Accetta Tutti",
        rejectAll: "Rifiuta Tutti",
        preferences: "Personalizza",
        titlePref: "Preferenze Tracciamento",
        essentialTitle: "Essenziali / Tecnici",
        essentialDesc: "Necessari per il login, la sicurezza e il salvataggio della cantina. Non disattivabili.",
        analyticsTitle: "Statistici (Analytics)",
        analyticsDesc: "Ci aiutano a capire in forma anonima come viene usata l'app per poterla migliorare.",
        marketingTitle: "Marketing e Profilazione",
        marketingDesc: "Consentono a noi e ai nostri partner di mostrarti annunci primi pertinenti e personalizzati.",
        savePreferences: "Salva Preferenze"
      },
      energyHeader: {
        ultimate: "VinoLogic ULTIMATE",
        pro: "VinoLogic PRO",
        subscribe: "Abbonati",
        toastSuccess: "+5 Energia Ricaricata!",
        premiumTitle: "Sei un utente Premium!",
        energyTitle: "L'Energia di VinoLogic",
        thanksSupport: "Grazie per aver scelto di supportarci! 🍷",
        asUser: "Come utente ",
        unlockedPotential: ", hai sbloccato il pieno potenziale della tua cantina virtuale.",
        perkAds: "Zero pubblicità in app",
        perkActions: "Azioni avanzate illimitate",
        perkDevelopment: "Sostieni lo sviluppo futuro",
        freeAppDesc: "Ci teniamo a offrirti un'app completa e gratuita in ogni sua singola funzione.",
        energySystemDesc: "Per garantire che VinoLogic rimanga sostenibile e accessibile a tutti, utilizziamo un sistema ad \"Energia\" (1⚡ = 1 azione avanzata).",
        howToRefill: "Come ricaricare l'energia?",
        watchVideo: "Guarda un breve video",
        freeGetEnergy: "Gratis • Ottieni 5⚡",
        buyGlass: "Offrici un calice!",
        unlockAppDesc: "Sblocca l'app, elimina i limiti e supporta il nostro team."
      },
      outOfEnergy: {
        title: "Energia Esaurita",
        freeAppMsg: "Ci teniamo a offrirti un'app completa e gratuita in ogni sua singola funzione.",
        systemMsg: "Per garantire che VinoLogic rimanga sostenibile e accessibile a tutti, utilizziamo un sistema ad Energia (1⚡ = 1 azione avanzata).",
        resumeAnalysis: "Riprendi subito le tue analisi:",
        watchShortAd: "Guarda un breve spot",
        refillFreeSub: "Ricarica subito +5⚡ gratis",
        upgradeProTitle: "Passa a VinoLogic PRO",
        upgradeProSub: "Energia infinita e zero pubblicità"
      },
      rewardedAd: {
        connectAdMob: "Connessione AdMob in corso...",
        notSupported: "Libreria non supportata in questo ambiente.",
        errorSdk: "Errore di inizializzazione SDK: ",
        errorGeneric: "Errore AdMob: ",
        expoSimulation: "Expo Go: Simulazione Video in corso...",
        expoHint: "(Attendi 2 secondi per ottenere l'energia)",
        webEndingIn: "Il video premio terminerà tra {time}s",
        webRewardIncoming: "Ricompensa in arrivo...",
        webPartnerTitle: "VinoLogic Partners",
        webPartnerSub: "Scopri i migliori terroir del mondo.",
        webSponsoredBadge: "Spot Sponsorizzato",
        webCloseAction: "Chiudi Spot (Nessuna Ricompensa)"
      }
    }
  },
  en: {
    global: {
      ok: "OK",
      cancel: "Cancel",
      save: "Save",
      error: "Error",
      success: "Success",
      loading: "Loading...",
      energy: "Energy",
      premiumPro: "VinoLogic PRO",
      premiumUltimate: "VinoLogic ULTIMATE"
    },
    alerts: {
      missingDataTitle: "Data Update",
      serverOverload: "AI servers are temporarily overloaded. Your energy has been refunded."
    },
    login: {
      subtitle: "Your personal wine cellar in your pocket",
      tabs: {
        login: "Log In",
        register: "Sign Up with e-mail"
      },
      registration: {
        nameLabel: "What is your name?",
        namePlaceholder: "Your name (or nickname)",
        langCountryLabel: "Language and Country"
      },
      fields: {
        emailLabel: "Email Address",
        emailPlaceholder: "e.g., mario@email.com",
        passwordLabel: "Password",
        passwordPlaceholderLogin: "Enter password",
        passwordPlaceholderRegister: "Create a secure password",
        passwordHint: "* Minimum 6 characters"
      },
      compliance: {
        adultDeclaration: "I declare that I am of legal age",
        termsReadAndAccept: "I have read and accept the ",
        termsOfService: "Terms of Service",
        andThe: " and the ",
        privacyPolicy: "Privacy Policy"
      },
      buttons: {
        loginAction: "Access Cellar",
        registerAction: "Create Account",
        forgotPassword: "Forgot your password?",
        dismiss: "Got it",
        cancel: "Cancel",
        // INTEGRAZIONE CHIAVI SOCIAL ED EMAIL ADATTIVE EN
        continueWithGoogle: "Continue with Google",
        continueWithApple: "Continue with Apple",
        orWithEmail: "or with email"
      },
      biometricSelector: {
        title: "Select Account",
        subtitle: "Which account do you want to access?",
        prompt: "Log in as"
      },
      alerts: {
        missingCredentialsTitle: "Warning",
        missingCredentialsMsg: "Please enter your email and password to log in.",
        verifyEmailTitle: "Email Verification",
        verifyEmailMsg: "You must verify your email first. Please check your inbox (including Spam).",
        loginErrorTitle: "Login Error",
        loginErrorMsg: "Incorrect credentials or account does not exist.",
        biometricSetupTitle: "Warning",
        biometricSetupMsg: "You must log in with your password at least once to enable biometrics.",
        vaultErrorTitle: "Error",
        vaultErrorMsg: "Unable to read credential vault.",
        biometricFailTitle: "Error",
        biometricFailMsg: "Biometric login failed or cancelled.",
        missingFieldsTitle: "Warning",
        missingFieldsMsg: "Name, Email, and Password are required.",
        shortPasswordTitle: "Warning",
        shortPasswordMsg: "Password must be at least 6 characters long.",
        adultRequiredTitle: "Legal Age Required",
        adultRequiredMsg: "You must confirm that you are of legal age to proceed with registration.",
        termsRequiredTitle: "Acceptance Required",
        termsRequiredMsg: "You must read and accept the Terms of Service and Privacy Policy to register.",
        registerSuccessTitle: "Welcome to the Vault! 🎁",
        registerSuccessMsg: "Account successfully created! We have gifted you 5 Energy Points to start exploring the AI.\n\nClick the link sent to your email to activate your account.",
        emailInUseTitle: "Warning",
        emailInUseMsg: "An account is already registered with this email.",
        resetEmailSentTitle: "Email Sent",
        resetEmailSentMsg: "Check your inbox to reset your password.",
        resetErrorTitle: "Error",
        resetErrorMsg: "User not found or system error.",
        ageInfoTitle: "Minimum Age Requirement",
        ageInfoMsg: "VinoLogic is an application dedicated to classification and the world of wine.\n\nIn compliance with current legal regulations regarding alcohol and digital Store policies, it is mandatory to be of legal age (18+ years) to create an account.\n\nBy making a false declaration, the user assumes full civil and criminal liability.",
        linkErrorMsg: "Unable to open link.",
        webBiometricMsg: "Biometric access is only available on Smartphones."
      }
    },
    profile: {
      title: "Settings",
      accountVerified: "Account Verified",
      upgrade: {
        planMonthly: "Your plan: Monthly",
        planAnnual: "Your plan: Annual",
        desc: "Want to remove automatic renewals forever or save long-term? Switch to the Caveau plan. The cost will be automatically calculated by the store.",
        button: "Explore Lifetime Upgrade"
      },
      sections: {
        personalData: "Personal Data",
        security: "Security",
        legal: "Legal Information"
      },
      fields: {
        nameLabel: "Name or Nickname",
        namePlaceholder: "Your name",
        langCountryLabel: "Language and Country",
        passwordLabel: "New Password (minimum 6 characters)",
        passwordPlaceholder: "Enter new password",
        confirmPasswordLabel: "Confirm New Password",
        confirmPasswordPlaceholder: "Repeat new password"
      },
      buttons: {
        saveProfile: "Save Personal Data",
        changePassword: "Change Password",
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        cookies: "Manage Cookie Preferences",
        deleteAccount: "Delete Account and Data"
      },
      dangerZoneDesc: "Deletion will permanently remove your cellar and data in compliance with GDPR. This action is irreversible.",
      deleteModal: {
        title: "Leaving so soon?",
        message: "We're sorry to see you go! Your virtual cellar will be lost forever. 🍷\n\nIn compliance with GDPR (Irreversible action), confirming will delete all your data, wines, and account from our servers.\n\nEnter your password to confirm identity:",
        passwordPlaceholder: "Your password",
        stayButton: "I changed my mind, I'm staying!",
        confirmButton: "Delete everything permanently"
      },
      alerts: {
        saveSuccessTitle: "Profile Updated",
        saveSuccessMsg: "Data saved successfully.",
        saveErrorTitle: "Error",
        saveErrorMsg: "Unable to save data, please try again later.",
        emptyFieldsTitle: "Error",
        emptyFieldsMsg: "Please fill in all fields.",
        shortPasswordTitle: "Error",
        shortPasswordMsg: "Password must be at least 6 characters long.",
        mismatchPasswordTitle: "Error",
        mismatchPasswordMsg: "Passwords do not match.",
        passwordSuccessTitle: "Success",
        passwordSuccessMsg: "Password updated successfully!",
        passwordErrorTitle: "Error",
        passwordErrorMsg: "Unable to update password at this time.",
        deleteWarningTitle: "Warning",
        deleteWarningMsg: "Enter your password to confirm deletion.",
        deleteWrongPasswordTitle: "Error",
        deleteWrongPasswordMsg: "The password entered is incorrect. Please try again.",
        deleteErrorTitle: "Error",
        deleteErrorMsg: "Unable to complete operation. Please contact support.",
        linkErrorTitle: "Error",
        linkErrorMsg: "Unable to open link in browser."
      }
    },
    home: {
      header: {
        welcome: "Welcome back,",
        loadingName: "Loading..."
      },
      hero: {
        title: "Your Sommelier",
        subtitle: "Ask for the perfect pairing",
        toggleEat: "What are you eating?",
        toggleDrink: "What are you drinking?",
        placeholderFood: "Steak, fish...",
        placeholderWine: "Barolo, Chianti..."
      },
      results: {
        fromCellar: "From Cellar",
        toBuy: "To Buy",
        noMatchTitle: "No ideal match found",
        bestChoice: "Ideal Choice",
        locateAction: "Locate",
        openSheet: "Open Sheet",
        alternative: "The Alternative (Different Style)",
        expertAdvice: "The expert's advice:",
        perfectDishes: "Perfect dishes for this wine:"
      },
      sections: {
        management: "Cellar Management"
      },
      grid: {
        addWineTitle: "Add Wine Reference",
        addWineSub: "Scan label or enter manually",
        cellar3dTitle: "My 3D Cellar",
        cellar3dSub: "Physical layout",
        myWinesTitle: "My Wines",
        myWinesSubCalc: "Calculating...",
        myWinesSubLabels: "labels",
        statsTitle: "Analytics",
        statsSub: "Value and statistics",
        mapTitle: "Your Vineyards",
        mapSub: "Geographical map"
      },
      buttons: {
        logoutConfirmTitle: "Log Out",
        logoutConfirmMsg: "Are you sure you want to log out of your VinoLogic account?",
        cancel: "Cancel",
        exit: "Exit",
        dismiss: "Got it"
      },
      alerts: {
        logoutErrorMsg: "Unable to log out. Please try again.",
        adSuccessTitle: "Energy Refilled",
        adSuccessMsg: "You received +5⚡.\nNow you can ask the Sommelier for a pairing!"
      }
    },
    addWine: {
      title: "Add Wine Reference",
      camera: {
        instructions: "Frame the label inside the box",
        take: "Shoot",
        shootPhoto: "Take Photo",
        smartCam: "Smart Camera",
        fromGallery: "From Gallery",
        uploadImg: "Upload an image",
        permissionDeniedTitle: "Permission Denied",
        permissionDeniedMsg: "You must grant camera access to use this feature.",
        shootErrorTitle: "Capture Error",
        shootErrorMsg: "Could not capture image.",
        galleryErrorTitle: "Error",
        galleryErrorMsg: "Unable to load image from gallery."
      },
      loading: {
        title: "Analyzing label...",
        sub: "The Sommelier is studying the bottle."
      },
      form: {
        successBanner: "Data extracted! Please review the sheet.",
        bottles: "Bottles",
        type: "Type",
        types: {
          rosso: "Red",
          bianco: "White",
          bollicine: "Sparkling",
          rosato: "Rosé",
          dolce: "Sweet"
        },
        labels: {
          name: "Wine Name",
          annata: "Vintage",
          vitigno: "Grape Variety",
          regione: "Region",
          gradazione: "Alcohol Content",
          affinamento: "Aging Method",
          temperatura: "Serving Temp",
          drinkingWindow: "Drinking Window",
          recalcWindow: "Recalculating window...",
          pairingTags: "Pairings"
        },
        placeholders: {
          vintageInput: "E.g., 2019"
        }
      },
      aiActions: {
        marketAnalysis: "Market analysis...",
        estimateValue: "Estimate bottle value (1⚡)",
        estimation: "Estimate",
        sommelierNote: "Type Note",
        generateReview: "Generate Sommelier review (1⚡)"
      },
      buttons: {
        saveAndPlace: "Save and place in cellar",
        saveOnly: "Save to my wines - place later",
        cancelOp: "Cancel operation",
        vintageNotFound: "Vintage not found",
        vintageModalMsg: "The Sommelier could not deduce the vintage of this bottle. If you know the year, enter it below.",
        unknownVintage: "Unknown (S.A.)",
        saveYear: "Save Year",
        editTitle: "Edit",
        valueInfoTitle: "Value Information",
        valueInfoMsg: "The value shown is a purely indicative estimation calculated by Artificial Intelligence based on the historical average market price of the bottle.\n\nIt does not constitute accurate financial valuation."
      },
      alerts: {
        adCompleteTitle: "Refill Completed",
        adCompleteMsg: "+5 Energy Points successfully added! You can now analyze the label.",
        invalidImgTitle: "Invalid Image",
        invalidImgMsg: "No recognizable bottle. Please try another photo. Energy was not deducted.",
        technicalErrorTitle: "Technical Error",
        technicalErrorMsg: "AI servers are temporarily overloaded. Your energy has been refunded. Please fill in manually or try again shortly.",
        nameRequiredTitle: "Warning",
        nameRequiredMsg: "Wine name is required.",
        saveSuccessTitle: "Success!",
        saveSuccessMsg: "Wine saved to your collection. You can position it in the cellar later.",
        saveCloudErrorTitle: "Error",
        saveCloudErrorMsg: "Unable to save wine to the cloud."
      }
    },
    catalog: {
      title: "Your Cellar",
      loading: "Loading cellar...",
      tabs: {
        present: "Present",
        past: "Past"
      },
      filters: {
        readyToDrink: "🍷 Ready to drink",
        all: "All"
      },
      empty: {
        title: "No references",
        text: "There are no wines matching your filters in this section."
      },
      buttons: {
        add: "Add"
      }
    },
    details: {
      title: "Wine Details",
      statusPast: "Finished",
      statusPresent: "in Inventory",
      valuation: "Your evaluation:",
      alignBanner: {
        desc: "This bottle was inserted in an older version. Tap here to align it with current information.",
        action: "Align Sheet (1⚡)"
      },
      translateBanner: {
        title: "Sheet Translation",
        desc: "The descriptive texts for this wine are saved in another language. Regenerate and adapt the sheet in your current language.",
        action: "Update to English (1⚡)"
      },
      valueBox: {
        marketAnalysis: "Market analysis in progress...",
        revealValue: "Reveal estimated value (1⚡)",
        estimation: "Estimate"
      },
      placement: {
        title: "Cellar Placement",
        bottleSingle: "Bottle",
        bottlePlural: "Bottles",
        show3d: "Show in 3D Cellar"
      },
      sections: {
        theWine: "The Wine",
        pairings: "Recommended Pairings",
        sommelierIa: "Sommelier Details (AI)",
        techSheet: "Technical Sheet"
      },
      sommelierPrompt: {
        text: "Discover the history, unique characteristics, and secrets of this wine with our virtual Master Sommelier.",
        action: "Generate review (1⚡)"
      },
      modals: {
        addBottlesTitle: "Add Bottles",
        addBottlesMsg: "How many new bottles of this wine do you want to add to inventory?",
        saveOnlyList: "Save to wine list only",
        placeNowCaveau: "Place now in Cellar",
        unplacedInventory: "From inventory (Storage)",
        from3dCellar: "From 3D Cellar",
        goAction: "Go ⚡",
        stappataTitle: "Uncork Bottle",
        stappataMsg: "Where did you take the bottle you are about to consume from?",
        insertVintageTitle: "Insert Vintage",
        insertVintageMsg: "To calculate the correct drinking window and market value, enter the year of the bottle.",
        confirmBtn: "Confirm",
        editDataTitle: "Edit Data",
        storageLoc: "Storage Location (Optional)",
        recalcAction: "Recalculate ⚡",
        recalcHint: "You edited the vintage. It is recommended to recalculate the window.",
        recalcLoading: "Recalculating window...",
        vintageLabelHint: "e.g., 2019 or S.A.",
        locationLabelHint: "Shelf, Cabinet...",
        pairingLabelHint: "Pairings (separated by comma)",
        descLabel: "Short Description",
        saveChanges: "Save Changes"
      },
      alerts: {
        bottleFinishedTitle: "Bottle Finished",
        bottleFinishedMsg: "You consumed the last bottle. The wine has been moved to past references.",
        cinCinTitle: "Cheers! 🍷",
        cinCinMsg: "Bottle uncorked from storage. Inventory updated successfully.",
        addedTitle: "Added",
        addedMsg: "bottles added to the list.",
        deleteConfirmTitle: "Delete Permanently",
        deleteConfirmMsg: "Are you sure you want to delete this bottle? This operation cannot be undone.",
        deleteActionBtn: "Delete",
        emptyVintageTitle: "Warning",
        emptyVintageMsg: "Please enter a valid vintage to calculate the window.",
        recalcErrorMsg: "Unable to recalculate the window at this time.",
        saveEditSuccessMsg: "The wine details have been updated successfully.",
        saveEditErrorMsg: "Unable to save changes. Please try again."
      }
    },
    map: {
      title: "Your Vineyards",
      dashboard: {
        terroirTitle: "The Terroir",
        terroirSub: "Tap the wine glasses to discover how climate influences your wines.",
        findVinesTitle: "Find Vineyards",
        findVinesSub: "Locate {count} new bottles (1⚡)",
        cellarMappedTitle: "Cellar Mapped",
        cellarMappedSub: "All your bottles have been located."
      },
      sheet: {
        territorialAnalysis: "Territorial Analysis",
        expertReport: "The Expert's Report",
        recalcAudit: "Recalculate Terroir Audit (1⚡)",
        generateAudit: "Generate Audit (1⚡)",
        firstAuditPrompt: "Generate your first Audit to discover the impact of climate on your wines.",
        myWinesHere: "My wines here ({count}):",
        unspecifiedRegion: "Unspecified",
        notSpecified: "Unspecified"
      },
      alerts: {
        adCompleteTitle: "Refill Completed",
        adCompleteMsg: "+5 Energy Points added! Now you can scan the terroir.",
        locateSuccessTitle: "Localization Completed",
        locateSuccessMsg: "Your bottles have been successfully placed on the map.",
        terroirErrorTitle: "Servers Busy",
        terroirErrorMsg: "Unable to explore terroir right now. Your energy has been refunded.",
        geoErrorTitle: "Sommelier Busy",
        geoErrorMsg: "Unable to complete geolocalization now. Your energy has been refunded."
      }
    },
    stats: {
      title: "Analytics & Statistics",
      loading: "Loading statistics...",
      hero: {
        subtitle: "Estimated Collection Value",
        bottles: "Bottles in the Cellar",
        maturation: "Maturation Status",
        ready: "🍷 Ready to uncork",
        aging: "⏳ Aging / Resting"
      },
      suggestions: {
        title: "Which wine do you recommend uncorking?",
        sub: "The Sommelier selects the best bottles to open right now, right in their prime drinking window.",
        ask: "Ask the Sommelier (1⚡)",
        option: "Option",
        openSheet: "Open Sheet",
        more: "See other proposals (1⚡)",
        emptyTitle: "Empty Cellar",
        emptyMsg: "Add some bottles before asking for a recommendation!"
      },
      audit: {
        title: "Cellar Composition",
        outdated: "You have added or removed bottles. Recalculate to update charts.",
        translate: "The current analysis is saved in another language. Update to translate it to your current language.",
        expert: "The Expert's Report:",
        recalc: "Recalculate Audit (1⚡)",
        emptyTitle: "Oenological Classification",
        emptyText: "Generate your first Audit to catalog your wines like a true Michelin-starred Sommelier.",
        generate: "Generate Audit (1⚡)",
        successTitle: "Audit Completed",
        successMsg: "Charts and report have been successfully updated!"
      }
    },
    paywall: {
      title: "Unlock your Cellar's potential",
      sub: "Discover the plans we are preparing for you.",
      testBannerText: "This version is still in testing mode. Premium plans are not currently active. With the release of the first final version, you will have the opportunity to subscribe to support the project!",
      loadingPreview: "Loading preview offers...",
      disclaimerText: "Purchases disabled during the test phase.",
      soonAvailable: "Coming soon",
      notActiveTest: "Not active in test version yet",
      restoreNotNeeded: "Restore purchases currently not needed",
      plans: {
        monthly: {
          title: "Monthly",
          period: "/month",
          catchphrase: "Buy us a glass!",
          badge: null,
          f1: "Zero ads",
          f2: "Unlimited AI",
          f3: "Team support"
        },
        annual: {
          title: "Annual",
          period: "/year",
          catchphrase: "Smart choice: -16%",
          badge: "Recommended",
          f1: "All Monthly benefits",
          f2: "16% Discount",
          f3: "2 Months free"
        },
        lifetime: {
          title: "Caveau",
          period: "One-time",
          catchphrase: "Yours forever.",
          badge: "Best Deal",
          f1: "All Annual benefits",
          f2: "No renewals",
          f3: "Lifetime unlock"
        }
      }
    },
    caveau: {
      title: "3D Cellar",
      localizedWine: "Located Wine",
      activeSpaceFor: "Active space for:",
      aiRecommendation: "AI Sommelier Recommendation (1⚡)",
      deselect: "Deselect",
      searchResultsFor: "Search results for",
      clearSearch: "Clear ✖",
      loadingCellar: "Setting up Cellar...",
      loadingCellarSub: "The first load will take a few seconds.",
      emptyCellars: "You don't have any cellars structured yet.",
      buildFirst: "Build the first one",
      expand: {
        row: "Rows",
        col: "Columns",
        depth: "Back Row"
      },
      buttons: {
        place: "Place",
        search: "Search",
        edit: "Edit",
        dismantle: "Dismantle"
      },
      modals: {
        inventoryToPlace: "Inventory to Place",
        inventoryEmpty: "All your bottles have been neatly stored in the cellar!",
        searchTitle: "3D Highlighter",
        searchPlaceholder: "Start typing (e.g., Barolo)...",
        searchSuggestionsLabel: "Suggestions (Cost 1⚡) :",
        selectedBottle: "Selected Bottle",
        slotActionMsg: "What do you want to do with this space?",
        consumeAction: "Uncork and consume (1⚡)",
        returnToDeposit: "Return to storage (1⚡)",
        createCellarTitle: "Build structured cellar",
        cellarNameLabel: "Name (E.g., Tavern Fridge)",
        cellarNamePlaceholder: "Write a name...",
        cellarTempLabel: "Operating Temperature (°C)",
        cellarArrangementLabel: "Arrangement",
        arrangements: {
          horizontal: "Laid Down",
          vertical: "Standing Up"
        },
        dimensions: {
          rows: "Rows",
          cols: "Columns"
        },
        createBtn: "Create",
        editCellarTitle: "Modify Structure Parameters",
        cellarIdentifierLabel: "Cellar Identifier",
        bottleArrangementLabel: "Bottle Arrangement",
        editHint: "* Dimensions of rows and columns are expandable directly using the arrows on the 3D screen.",
        closeBtn: "Close"
      },
      alerts: {
        notEmptyTitle: "Structure Not Empty",
        notEmptyMsg: "Cannot delete because bottles are present. Please remove all bottles from the cellar first before deleting.",
        deleteConfirmTitle: "Dismantle Cellar",
        deleteConfirmMsg: "Are you sure you want to destroy the empty structure \"{name}\"?",
        noWineSelectedTitle: "No wine selected",
        noWineSelectedMsg: "First select a wine by clicking 'Place', then tap on an empty space.",
        consumeSuccessTitle: "Cheers! 🍷",
        consumeSuccessMsg: "You uncorked {name}. It has been removed from the cellar.",
        aiPlacementTitle: "AI Sommelier Advice ⚡",
        placeErrorMsg: "Unable to place the bottle.",
        updateErrorMsg: "Unable to update cellar.",
        updateDetailsErrorMsg: "Unable to update structure parameters.",
        aiConnectionErrorMsg: "Unable to connect to virtual assistant. Your energy has been credited back."
      }
    },
    components: {
      cookieConsent: {
        title: "Your Privacy matters",
        desc: "We use technical cookies strictly necessary for the app's operation (e.g., to keep you logged in). In addition, with your consent, we would like to use statistical and profiling cookies to improve the app and show you personalized content.",
        acceptAll: "Accept All",
        rejectAll: "Reject All",
        preferences: "Customize",
        titlePref: "Tracking Preferences",
        essentialTitle: "Essential / Technical",
        essentialDesc: "Required for login, security, and saving your cellar data. Cannot be disabled.",
        analyticsTitle: "Statistical (Analytics)",
        analyticsDesc: "They help us understand anonymously how the app is used in order to improve it.",
        marketingTitle: "Marketing and Profiling",
        marketingDesc: "They allow us and our partners to show you relevant and tailored advertisements.",
        savePreferences: "Save Preferences"
      },
      energyHeader: {
        ultimate: "VinoLogic ULTIMATE",
        pro: "VinoLogic PRO",
        subscribe: "Subscribe",
        toastSuccess: "+5 Energy Refilled!",
        premiumTitle: "You are a Premium user!",
        energyTitle: "VinoLogic Energy",
        thanksSupport: "Thank you for choosing to support us! 🍷",
        asUser: "As a ",
        unlockedPotential: " user, you have unlocked the full potential of your virtual cellar.",
        perkAds: "Zero in-app advertisements",
        perkActions: "Unlimited advanced actions",
        perkDevelopment: "Support future development",
        freeAppDesc: "We care about offering you a complete and free app in every single feature.",
        energySystemDesc: "To ensure that VinoLogic remains sustainable and accessible to everyone, we use an \"Energy\" system (1⚡ = 1 advanced action).",
        howToRefill: "How to refill energy?",
        watchVideo: "Watch a short video",
        freeGetEnergy: "Free • Get 5⚡",
        buyGlass: "Buy us a glass!",
        unlockAppDesc: "Unlock the app, remove limits, and support our team."
      },
      outOfEnergy: {
        title: "Energy Depleted",
        freeAppMsg: "We care about offering you a complete and free app in every single feature.",
        systemMsg: "To ensure that VinoLogic remains sustainable and accessible to everyone, we use an Energy system (1⚡ = 1 advanced action).",
        resumeAnalysis: "Resume your analysis immediately:",
        watchShortAd: "Watch a short ad",
        refillFreeSub: "Refill +5⚡ immediately for free",
        upgradeProTitle: "Upgrade to VinoLogic PRO",
        upgradeProSub: "Infinite energy and zero ads"
      },
      rewardedAd: {
        connectAdMob: "Connecting to AdMob...",
        notSupported: "Library not supported in this environment.",
        errorSdk: "SDK initialization error: ",
        errorGeneric: "AdMob Error: ",
        expoSimulation: "Expo Go: Video Simulation in progress...",
        expoHint: "(Wait 2 seconds to get energy)",
        webEndingIn: "The rewarded video will end in {time}s",
        webRewardIncoming: "Reward incoming...",
        webPartnerTitle: "VinoLogic Partners",
        webPartnerSub: "Discover the best terroirs in the world.",
        webSponsoredBadge: "Sponsored Ad",
        webCloseAction: "Close Ad (No Reward)"
      }
    }
  },
  fr: {
    global: {
      ok: "OK",
      cancel: "Annuler",
      save: "Sauvegarder",
      error: "Erreur",
      success: "Succès",
      loading: "Chargement...",
      energy: "Énergie",
      premiumPro: "VinoLogic PRO",
      premiumUltimate: "VinoLogic ULTIMATE"
    },
    alerts: {
      missingDataTitle: "Mise à jour des données",
      serverOverload: "Les serveurs IA sont temporairement surchargés. Votre énergie a été remboursée."
    },
    login: {
      subtitle: "Votre cave à vin personnelle dans votre poche",
      tabs: {
        login: "Connexion",
        register: "Inscription avec e-mail"
      },
      registration: {
        nameLabel: "Comment vous appelez-vous ?",
        namePlaceholder: "Votre nom (or pseudonyme)",
        langCountryLabel: "Langue et Pays"
      },
      fields: {
        emailLabel: "Adresse e-mail",
        emailPlaceholder: "ex. mario@email.com",
        passwordLabel: "Mot de passe",
        passwordPlaceholderLogin: "Entrez votre mot de passe",
        passwordPlaceholderRegister: "Créez un mot de passe sécurisé",
        passwordHint: "* Minimum 6 caractères"
      },
      compliance: {
        adultDeclaration: "Je déclare être majeur",
        termsReadAndAccept: "J'ai lu et j'accepte les ",
        termsOfService: "Conditions d'utilisation",
        andThe: " et la ",
        privacyPolicy: "Politique de confidentialité"
      },
      buttons: {
        loginAction: "Accéder à la cave",
        registerAction: "Créer un compte",
        forgotPassword: "Mot de passe oublié ?",
        dismiss: "Compris",
        cancel: "Annuler",
        // INTEGRAZIONE CHIAVI SOCIAL ED EMAIL ADATTIVE FR
        continueWithGoogle: "Continuer avec Google",
        continueWithApple: "Continuer avec Apple",
        orWithEmail: "ou par e-mail"
      },
      biometricSelector: {
        title: "Choisir un compte",
        subtitle: "Avec quel compte souhaitez-vous vous connecter ?",
        prompt: "Se connecter en tant que"
      },
      alerts: {
        missingCredentialsTitle: "Attention",
        missingCredentialsMsg: "Veuillez saisir votre e-mail et votre mot de passe pour vous connecter.",
        verifyEmailTitle: "Vérification de l'e-mail",
        verifyEmailMsg: "Vous devez d'abord vérifier votre e-mail. Veuillez vérifier votre boîte de réception (y compris les indésirables).",
        loginErrorTitle: "Erreur de connexion",
        loginErrorMsg: "Identifiants incorrects ou compte inexistant.",
        biometricSetupTitle: "Attention",
        biometricSetupMsg: "Vous devez vous connecter avec votre mot de passe au moins une fois pour activer la biométrie.",
        vaultErrorTitle: "Erreur",
        vaultErrorMsg: "Impossible de lire le coffre-fort des identifiants.",
        biometricFailTitle: "Erreur",
        biometricFailMsg: "La connexion biométrique a échoué ou a été annulée.",
        missingFieldsTitle: "Attention",
        missingFieldsMsg: "Le nom, l'e-mail et le mot de passe sont obligatoires.",
        shortPasswordTitle: "Attention",
        shortPasswordMsg: "Le mot de passe doit contenir au moins 6 caractères.",
        adultRequiredTitle: "Âge légal requis",
        adultRequiredMsg: "Vous devez confirmer que vous êtes majeur pour procéder à l'inscription.",
        termsRequiredTitle: "Acceptation requise",
        termsRequiredMsg: "Vous devez lire et accepter les Conditions d'utilisation et la Politique de confidentialité pour vous inscrire.",
        registerSuccessTitle: "Bienvenue nel Caveau! 🎁",
        registerSuccessMsg: "Compte créé avec succès ! Nous vous offrons 5 points d'énergie pour commencer à explorer l'IA.\n\nCliquez sur le lien envoyé par e-mail pour activer votre compte.",
        emailInUseTitle: "Attention",
        emailInUseMsg: "Un compte est déjà enregistré avec cet e-mail.",
        resetEmailSentTitle: "E-mail envoyé",
        resetEmailSentMsg: "Vérifiez votre boîte de réception pour réinitialiser votre mot de passe.",
        resetErrorTitle: "Erreur",
        resetErrorMsg: "Utilisateur introuvable ou erreur système.",
        ageInfoTitle: "Exigence d'âge minimum",
        ageInfoMsg: "VinoLogic is un'application dédiée à la classification et au monde du vin.\n\nConformément aux réglementations légales en vigueur concernant l'alcool et aux politiques des magasins numériques, il est obligatoire d'être majeur (18 ans et plus) pour créer un compte.\n\nEn faisant une fausse déclaration, l'utilisateur assume l'entière responsabilité civile et pénale.",
        linkErrorMsg: "Impossible d'ouvrir le lien.",
        webBiometricMsg: "La connexion biométrique est uniquement disponible sur Smartphone."
      }
    },
    profile: {
      title: "Paramètres",
      accountVerified: "Compte vérifié",
      upgrade: {
        planMonthly: "Votre forfait : Mensuel",
        planAnnual: "Votre forfait : Annuel",
        desc: "Vous voulez supprimer les renouvellements automatiques à vie ou économiser à long terme ? Passez au forfait Caveau. Le coût sera calculé automatiquement par le store.",
        button: "Explorer l'abonnement à vie"
      },
      sections: {
        personalData: "Données personnelles",
        security: "Sécurité",
        legal: "Informations légales"
      },
      fields: {
        nameLabel: "Nom ou pseudonyme",
        namePlaceholder: "Votre nom",
        langCountryLabel: "Langue et Pays",
        passwordLabel: "Nouveau mot de passe (minimum 6 caractères)",
        passwordPlaceholder: "Entrez le nouveau mot de passe",
        confirmPasswordLabel: "Confirmer le nouveau mot de passe",
        confirmPasswordPlaceholder: "Répétez le nouveau mot de passe"
      },
      buttons: {
        saveProfile: "Enregistrer les données",
        changePassword: "Modifier le mot de passe",
        terms: "Conditions d'utilisation",
        privacy: "Politique de confidentialité",
        cookies: "Gérer les préférences de cookies",
        deleteAccount: "Supprimer le compte et les données"
      },
      dangerZoneDesc: "La suppression effacera définitivement votre cave et vos données conformément au RGPD. Cette action est irréversible.",
      deleteModal: {
        title: "Vous nous quittez déjà ?",
        message: "We're sorry to see you go! Your virtual cellar will be lost forever. 🍷\n\nConformément au RGPD (Action irréversible), la confirmation supprimera toutes vos données, vins et compte de nos serveurs.\n\nSaisissez votre mot de passe pour confirmer votre identité :",
        passwordPlaceholder: "Votre mot de passe",
        stayButton: "J'ai changé d'avis, je reste !",
        confirmButton: "Tout supprimer définitivement"
      },
      alerts: {
        saveSuccessTitle: "Profil mis à jour",
        saveSuccessMsg: "Données enregistrées avec succès.",
        saveErrorTitle: "Erreur",
        saveErrorMsg: "Impossible d'enregistrer les données, veuillez réessayer plus tard.",
        emptyFieldsTitle: "Erreur",
        emptyFieldsMsg: "Veuillez remplir tous les champs.",
        shortPasswordTitle: "Erreur",
        shortPasswordMsg: "Le mot de passe doit contenir au moins 6 caractères.",
        mismatchPasswordTitle: "Erreur",
        mismatchPasswordMsg: "Les mots de passe ne correspondent pas.",
        passwordSuccessTitle: "Succès",
        passwordSuccessMsg: "Mot de passe mis à jour avec succès !",
        passwordErrorTitle: "Erreur",
        passwordErrorMsg: "Impossible de mettre à jour le mot de passe pour le moment.",
        deleteWarningTitle: "Attention",
        deleteWarningMsg: "Entrez votre mot de passe pour confirmer la suppression.",
        deleteWrongPasswordTitle: "Erreur",
        deleteWrongPasswordMsg: "Le mot de passe saisi n'est pas correct. Veuillez réessayer.",
        deleteErrorTitle: "Erreur",
        deleteErrorMsg: "Impossible de terminer l'opération. Veuillez contacter le support.",
        linkErrorTitle: "Erreur",
        linkErrorMsg: "Impossible d'ouvrir le lien dans le navigateur."
      }
    },
    home: {
      header: {
        welcome: "Bon retour,",
        loadingName: "Chargement..."
      },
      hero: {
        title: "Votre Sommelier",
        subtitle: "Demandez l'accord parfait",
        toggleEat: "Que mangez-vous ?",
        toggleDrink: "Que buvez-vous ?",
        placeholderFood: "Steak, poisson...",
        placeholderWine: "Barolo, Chianti..."
      },
      results: {
        fromCellar: "De la cave",
        toBuy: "À acheter",
        noMatchTitle: "Aucun accord idéal trouvé",
        bestChoice: "Choix idéal",
        locateAction: "Localiser",
        openSheet: "Ouvrir la fiche",
        alternative: "L'alternative (style différent)",
        expertAdvice: "Le conseil de l'expert :",
        perfectDishes: "Plats parfaits pour ce vin :"
      },
      sections: {
        management: "Gestion de la cave"
      },
      grid: {
        addWineTitle: "Ajouter une référence",
        addWineSub: "Numériser ou saisir manuellement",
        cellar3dTitle: "Ma cave 3D",
        cellar3dSub: "Disposition physique",
        myWinesTitle: "Mes vins",
        myWinesSubCalc: "Calcul...",
        myWinesSubLabels: "étiquettes",
        statsTitle: "Analyses",
        statsSub: "Valeur et statistiques",
        mapTitle: "Vos Vignobles",
        mapSub: "Carte géographique"
      },
      buttons: {
        logoutConfirmTitle: "Déconnexion",
        logoutConfirmMsg: "Êtes-vous sûr de vouloir vous déconnecter de votre compte VinoLogic ?",
        cancel: "Annuler",
        exit: "Quitter",
        dismiss: "Compris"
      },
      alerts: {
        logoutErrorMsg: "Impossible de se déconnecter. Veuillez réessayer.",
        adSuccessTitle: "Énergie rechargée",
        adSuccessMsg: "Vous avez reçu +5⚡.\nVous pouvez maintenant demander l'accord au sommelier !"
      }
    },
    addWine: {
      title: "Ajouter une référence",
      camera: {
        instructions: "Cadrez l'étiquette dans la zone",
        take: "Prendre",
        shootPhoto: "Prendre une photo",
        smartCam: "Caméra intelligente",
        fromGallery: "Depuis la galerie",
        uploadImg: "Charger une image",
        permissionDeniedTitle: "Permission refusée",
        permissionDeniedMsg: "Vous devez accorder l'accès à l'appareil photo pour utiliser cette fonction.",
        shootErrorTitle: "Erreur de capture",
        shootErrorMsg: "Impossible de capturer l'image.",
        galleryErrorTitle: "Erreur",
        galleryErrorMsg: "Impossible de charger l'image depuis la galerie."
      },
      loading: {
        title: "Analyse de l'étiquette en cours...",
        sub: "Le sommelier étudie la bouteille."
      },
      form: {
        successBanner: "Données extraites ! Veuillez réviser la fiche.",
        bottles: "Bouteilles",
        type: "Type",
        types: {
          rosso: "Rouge",
          bianco: "Blanc",
          bollicine: "Effervescent",
          rosato: "Rosé",
          dolce: "Doux"
        },
        labels: {
          name: "Nom du vin",
          annata: "Millésime",
          vitigno: "Cépage",
          regione: "Région",
          gradazione: "Degré d'alcool",
          affinamento: "Méthode d'élevage",
          temperatura: "Temp. de service",
          drinkingWindow: "Apogée de consommation",
          recalcWindow: "Recalcul de la fenêtre...",
          pairingTags: "Accords"
        },
        placeholders: {
          vintageInput: "Ex: 2019"
        }
      },
      aiActions: {
        marketAnalysis: "Analyse du marché...",
        estimateValue: "Estimer la valeur (1⚡)",
        estimation: "Estimation",
        sommelierNote: "Note du sommelier",
        generateReview: "Générer la note du sommelier (1⚡)"
      },
      buttons: {
        saveAndPlace: "Enregistrer et placer en cave",
        saveOnly: "Enregistrer dans mes vins - placer plus tard",
        cancelOp: "Annuler l'opération",
        vintageNotFound: "Millésime non trouvé",
        vintageModalMsg: "Le sommelier n'a pas pu déduire le millésime de cette bouteille. Si vous connaissez l'année, saisissez-la ci-dessous.",
        unknownVintage: "Inconnu (S.A.)",
        saveYear: "Enregistrer l'année",
        editTitle: "Modifier",
        valueInfoTitle: "Informations sur la valeur",
        valueInfoMsg: "La valeur affichée est une estimation purement indicative calculée par l'Intelligence Artificielle sur la base du prix de marché moyen historique de la bouteille.\n\nElle ne constitue pas une évaluation financière précise."
      },
      alerts: {
        adCompleteTitle: "Recharge effectuée",
        adCompleteMsg: "+5 points d'énergie ajoutés avec succès ! Vous pouvez maintenant analyser l'étiquette.",
        invalidImgTitle: "Image invalide",
        invalidImgMsg: "Aucune bouteille reconnaissable. Veuillez réessayer avec une autre photo. L'énergie n'a pas été déduite.",
        technicalErrorTitle: "Erreur technique",
        technicalErrorMsg: "Les serveurs IA sont temporairement surchargés. Votre énergie a été remboursée. Veuillez remplir manuellement ou réessayer sous peu.",
        nameRequiredTitle: "Attention",
        nameRequiredMsg: "Le nom du vin est obligatoire.",
        saveSuccessTitle: "Succès !",
        saveSuccessMsg: "Vin enregistré dans votre collection. Vous pourrez le placer en cave plus tard.",
        saveCloudErrorTitle: "Erreur",
        saveCloudErrorMsg: "Impossible d'enregistrer le vin sur le cloud."
      }
    },
    catalog: {
      title: "Votre Cave",
      loading: "Chargement de la cave...",
      tabs: {
        present: "Présents",
        past: "Passées"
      },
      filters: {
        readyToDrink: "🍷 Prêt à boire",
        all: "Tous"
      },
      empty: {
        title: "Aucune référence",
        text: "Il n'y a pas de vins correspondants à vos filtres dans cette section."
      },
      buttons: {
        add: "Ajouter"
      }
    },
    details: {
      title: "Détails du vin",
      statusPast: "Terminée",
      statusPresent: "en Inventario",
      valuation: "Votre évaluation :",
      alignBanner: {
        desc: "Cette bouteille a été insérée dans une ancienne version. Appuyez ici pour l'aligner avec les informations actuelles.",
        action: "Aligner la fiche (1⚡)"
      },
      translateBanner: {
        title: "Traduction de la fiche",
        desc: "Les textes descriptifs de ce vin sont sauvegardés dans une autre langue. Régénérez et adaptez la fiche dans votre langue actuelle.",
        action: "Mettre à jour en Français (1⚡)"
      },
      valueBox: {
        marketAnalysis: "Analyse du marché en cours...",
        revealValue: "Révéler la valeur estimée (1⚡)",
        estimation: "Estimation"
      },
      placement: {
        title: "Emplacement en cave",
        bottleSingle: "Bouteille",
        bottlePlural: "Bouteilles",
        show3d: "Afficher dans la cave 3D"
      },
      sections: {
        theWine: "Le Vin",
        pairings: "Accords Recommandés",
        sommelierIa: "Dettagli del sommelier (IA)",
        techSheet: "Fiche Technique"
      },
      sommelierPrompt: {
        text: "Découvrez l'histoire, les caractéristiques uniques et les secrets de ce vin avec notre Master Sommelier virtuel.",
        action: "Générer la note (1⚡)"
      },
      modals: {
        addBottlesTitle: "Ajouter des bouteilles",
        addBottlesMsg: "Combien de nouvelles bouteilles de ce vin souhaitez-vous ajouter à votre inventaire ?",
        saveOnlyList: "Enregistrer uniquement dans la liste des vins",
        placeNowCaveau: "Placer maintenant dans la cave",
        unplacedInventory: "De l'inventaire (Stockage)",
        from3dCellar: "De la cave 3D",
        goAction: "Aller ⚡",
        stappataTitle: "Déboucher la bouteille",
        stappataMsg: "D'où avez-vous pris la bouteille que vous êtes sur le point de consommer ?",
        insertVintageTitle: "Insérer le millésime",
        insertVintageMsg: "Pour calculer la bonne fenêtre de consommation et la valeur marchande, saisissez l'année de la bouteille.",
        confirmBtn: "Confirmer",
        editDataTitle: "Modifier les données",
        storageLoc: "Lieu de stockage (Optionnel)",
        recalcAction: "Recalculer ⚡",
        recalcHint: "Vous avez modifié le millésime. Il est recommandé de recalculer la fenêtre.",
        recalcLoading: "Recalcul de la fenêtre...",
        vintageLabelHint: "ex. 2019 or S.A.",
        locationLabelHint: "Étagère, Armoire...",
        pairingLabelHint: "Accords (séparés par une virgule)",
        descLabel: "Brève description",
        saveChanges: "Enregistrer les modifications"
      },
      alerts: {
        bottleFinishedTitle: "Bouteille terminée",
        bottleFinishedMsg: "Vous avez consommé la dernière bouteille. Le vin a été déplacé dans les références passées.",
        cinCinTitle: "Santé ! 🍷",
        cinCinMsg: "Bouteille débouchée du stock. Inventaire mis à jour avec succès.",
        addedTitle: "Ajouté",
        addedMsg: "bouteilles ajoutées à la liste.",
        deleteConfirmTitle: "Supprimer définitivement",
        deleteConfirmMsg: "Êtes-vous sûr de vouloir supprimer cette bouteille ? Cette opération est irréversible.",
        deleteActionBtn: "Supprimer",
        emptyVintageTitle: "Attention",
        emptyVintageMsg: "Veuillez saisir un millésime valide pour calculer la fenêtre.",
        recalcErrorMsg: "Impossible de recalculer la fenêtre pour le moment.",
        saveEditSuccessMsg: "Les détails du vin ont été mis à jour avec succès.",
        saveEditErrorMsg: "Impossible d'enregistrer les modifications. Veuillez contacter le support."
      }
    },
    map: {
      title: "Vos Vignobles",
      dashboard: {
        terroirTitle: "Le Terroir",
        terroirSub: "Touchez les verres pour découvrir comment le climat influence vos vins.",
        findVinesTitle: "Trouver des Vignes",
        findVinesSub: "Localiser {count} nouvelles bouteilles (1⚡)",
        cellarMappedTitle: "Cave Cartographiée",
        cellarMappedSub: "Toutes vos bouteilles ont été localisées."
      },
      sheet: {
        territorialAnalysis: "Analyse Territoriale",
        expertReport: "Le Rapport de l'Expert",
        recalcAudit: "Recalculer l'Audit du Terroir (1⚡)",
        generateAudit: "Générer l'Audit (1⚡)",
        firstAuditPrompt: "Générez votre premier Audit pour découvrir l'impact du climat sur vos vins.",
        myWinesHere: "Mes vins ici ({count}):",
        unspecifiedRegion: "Non Spécifiée",
        notSpecified: "Non Spécifiée"
      },
      alerts: {
        adCompleteTitle: "Recharge Effectuée",
        adCompleteMsg: "+5 Points d'Énergie ajoutés ! Vous pouvez maintenant scanner le terroir.",
        locateSuccessTitle: "Localisation Terminée",
        locateSuccessMsg: "Vos bouteilles ont été placées avec succès sur la carte.",
        terroirErrorTitle: "Serveurs Occupés",
        terroirErrorMsg: "Impossible d'explorer le terroir pour le moment. Votre énergie a été remboursée.",
        geoErrorTitle: "Sommelier Occupé",
        geoErrorMsg: "Impossible de terminer la géolocalisation pour le moment. Votre énergie a été remboursée."
      }
    },
    stats: {
      title: "Analyses & Statistiques",
      loading: "Chargement delle statistiche...",
      hero: {
        subtitle: "Valeur Estimée de la Collection",
        bottles: "Bouteilles dans la Cave",
        maturation: "État de maturation",
        ready: "🍷 Prêtes à déboucher",
        aging: "⏳ En vieillissement / Repos"
      },
      suggestions: {
        title: "Quel vin me conseillez-vous de déboucher ?",
        sub: "Le Sommelier sélectionne les meilleures bouteilles à ouvrir en ce moment, en plein cœur avogée.",
        ask: "Demander au Sommelier (1⚡)",
        option: "Option",
        openSheet: "Ouvrir la fiche",
        more: "Voir d'autres propositions (1⚡)",
        emptyTitle: "Cave Vide",
        emptyMsg: "Ajoutez quelques bouteilles avant de demander un conseil !"
      },
      audit: {
        title: "Composition de la cave",
        outdated: "Vous avez ajouté ou retiré des bouteilles. Recalculez pour mettre à jour les graphiques.",
        translate: "L'analyse actuelle est enregistrée dans une autre langue. Mettez à jour pour la traduire.",
        expert: "Le Rapport de l'Expert :",
        recalc: "Recalculer l'Audit (1⚡)",
        emptyTitle: "Classification Œnologique",
        emptyText: "Générez votre premier Audit pour cataloguer vos vins comme un véritable Sommelier étoilé.",
        generate: "Générer l'Audit (1⚡)",
        successTitle: "Audit Terminato",
        successMsg: "Les graphiques et le rapport ont été mis à jour avec succès !"
      }
    },
    paywall: {
      title: "Débloquez le potentiel de votre cave",
      sub: "Découvrez les forfaits que nous vous préparons.",
      testBannerText: "Cette version è ancora in phase di test. Les forfaits premium ne sont pas actifs pour le moment. Lors de la première version définitive, vous aurez la possibilité de vous abonner pour soutenir le projet !",
      loadingPreview: "Chargement de l'aperçu des offres...",
      disclaimerText: "Achats désactivés pendant la phase de test.",
      soonAvailable: "Bientôt disponible",
      notActiveTest: "Pas encore actif dans la version de test",
      restoreNotNeeded: "Restauration des achats actuellement non nécessaire",
      plans: {
        monthly: {
          title: "Mensuel",
          period: "/mois",
          catchphrase: "Offrez-nous un verre !",
          badge: null,
          f1: "Zéro publicité",
          f2: "IA illimitée",
          f3: "Soutien à l'équipe"
        },
        annual: {
          title: "Annuel",
          period: "/an",
          catchphrase: "Choix intelligent : -16%",
          badge: "Recommandé",
          f1: "Tous les avantages du Mensuel",
          f2: "Réduction de 16%",
          f3: "2 mois gratuits"
        },
        lifetime: {
          title: "Caveau",
          period: "Une fois",
          catchphrase: "À vous pour toujours.",
          badge: "Meilleure offre",
          f1: "Tous les avantages de l'Annuel",
          f2: "Aucun renouvellement",
          f3: "Déblocage à vie"
        }
      }
    },
    caveau: {
      title: "Cave 3D",
      localizedWine: "Vin Localisé",
      activeSpaceFor: "Espace actif pour :",
      aiRecommendation: "Conseil Sommelier IA (1⚡)",
      deselect: "Désélectionner",
      searchResultsFor: "Résultats pour",
      clearSearch: "Effacer ✖",
      loadingCellar: "Allègement de la cave...",
      loadingCellarSub: "Le premier chargement prend quelques secondes.",
      emptyCellars: "Vous n'avez pas encore de cave structurée.",
      buildFirst: "Construire la première",
      expand: {
        row: "Étagère",
        col: "Colonne",
        depth: "Rangée Arrière"
      },
      buttons: {
        place: "Placer",
        search: "Chercher",
        edit: "Modifier",
        dismantle: "Démanteler"
      },
      modals: {
        inventoryToPlace: "Inventario a Placer",
        inventoryEmpty: "Toutes vos bouteilles ont été rangées proprement en cave !",
        searchTitle: "Surligneur 3D",
        searchPlaceholder: "Commencez à écrire (ex. Barolo)...",
        searchSuggestionsLabel: "Suggestions (Coût 1⚡) :",
        selectedBottle: "Bouteille Sélectionnée",
        slotActionMsg: "Que souhaitez-vous faire de cet espace ?",
        consumeAction: "Déboucher et consommer (1⚡)",
        returnToDeposit: "Remettre en stock (1⚡)",
        createCellarTitle: "Construire une Cave",
        cellarNameLabel: "Nom (Ex : Frigo Taverna)",
        cellarNamePlaceholder: "Écrire un nom...",
        cellarTempLabel: "Température de Fonctionnement (°C)",
        cellarArrangementLabel: "Disposition",
        arrangements: {
          horizontal: "Allongée",
          vertical: "Debout"
        },
        dimensions: {
          rows: "Rangées",
          cols: "Colonnes"
        },
        createBtn: "Créer",
        editCellarTitle: "Modifier les Paramètres de la Cave",
        cellarIdentifierLabel: "Identifiant de la Cave",
        bottleArrangementLabel: "Disposition des Bouteilles",
        editHint: "* Les dimensions des rangées et des colonnes sont extensibles directement à l'aide des flèches sur l'écran 3D.",
        closeBtn: "Fermer"
      },
      alerts: {
        notEmptyTitle: "Structure non vide",
        notEmptyMsg: "Impossible de supprimer car des bouteilles sont présentes. Veuillez retirer toutes les bouteilles de la cave avant de la supprimer.",
        deleteConfirmTitle: "Dismantle la cave",
        deleteConfirmMsg: "Êtes-vous sûr de vouloir détruire la structure vide \"{name}\" ?",
        noWineSelectedTitle: "Aucun vin sélectionné",
        noWineSelectedMsg: "Sélectionnez d'abord un vin en cliquant sur 'Placer', puis touchez un espace vide.",
        consumeSuccessTitle: "Santé ! 🍷",
        consumeSuccessMsg: "Vous avez débouché {name}. Il a été retiré de la cave.",
        aiPlacementTitle: "Conseil Sommelier IA ⚡",
        placeErrorMsg: "Impossible de placer la bouteille.",
        updateErrorMsg: "Impossible de mettre à jour la cave.",
        updateDetailsErrorMsg: "Impossible de modifier les paramètres de la structure.",
        aiConnectionErrorMsg: "Impossible de se connecter à l'assistant virtuel. Votre énergie a été recréditée."
      }
    },
    components: {
      cookieConsent: {
        title: "Protection de la vie privée",
        desc: "Nous utilisons des cookies techniques strictement nécessaires au fonctionnement dell'application (ex. pour vous maintenir connecté). De plus, avec votre consentement, nous aimerions utiliser des cookies statistiques et de profilage pour améliorer l'application et vous présenter des contenus personnalisés.",
        acceptAll: "Tout accepter",
        rejectAll: "Tout refuser",
        preferences: "Personnaliser",
        titlePref: "Préférences de suivi",
        essentialTitle: "Essentiels / Techniques",
        essentialDesc: "Nécessaires pour la connexion, la sécurité et la sauvegarde de la cave. Non désactivables.",
        analyticsTitle: "Statistiques (Analytics)",
        analyticsDesc: "Ils nous aident à comprendre de manière anonyme comment l'application est utilisée afin de l'améliorer.",
        marketingTitle: "Marketing et profilage",
        marketingDesc: "Ils nous permettent, ainsi qu'à nos partenaires, de vous afficher des publicités pertinentes et personnalisées.",
        savePreferences: "Sauvegarder les préférences"
      },
      energyHeader: {
        ultimate: "VinoLogic ULTIMATE",
        pro: "VinoLogic PRO",
        subscribe: "S'abonner",
        toastSuccess: "+5 Énergie rechargée !",
        premiumTitle: "Vous êtes un utilisateur Premium !",
        energyTitle: "L'Énergie de VinoLogic",
        thanksSupport: "Merci d'avoir choisi de nous soutenir ! 🍷",
        asUser: "En tant qu'utilisateur ",
        unlockedPotential: ", vous avez débloqué tout le potentiel de votre cave virtuelle.",
        perkAds: "Zéro publicité dans l'application",
        perkActions: "Actions avancées illimitées",
        perkDevelopment: "Soutenir le développement futur",
        freeAppDesc: "Nous tenons à vous offrir une application complète et gratuite dans chacune de ses fonctions.",
        energySystemDesc: "Pour garantir que VinoLogic reste durable et accessible à tous, nous utilisons un système d'« Énergie » (1⚡ = 1 action avancée).",
        howToRefill: "Comment recharger l'énergie ?",
        watchVideo: "Regarder une courte vidéo",
        freeGetEnergy: "Gratuit • Obtenez 5⚡",
        buyGlass: "Offrez-nous un verre !",
        unlockAppDesc: "Débloquez l'application, supprimez les limites et soutenez notre équipe."
      },
      outOfEnergy: {
        title: "Énergie épuisée",
        freeAppMsg: "Nous tenons à vous offrir une application complète et gratuite dans chacune de ses fonctions.",
        systemMsg: "Pour garantir que VinoLogic reste durable et accessible à tous, nous utilisons un système d'Énergie (1⚡ = 1 action avancée).",
        resumeAnalysis: "Reprenez vos analyses immédiatement :",
        watchShortAd: "Regarder un court vidéo",
        refillFreeSub: "Rechargez immédiatement +5⚡ gratuitement",
        upgradeProTitle: "Passer à VinoLogic PRO",
        upgradeProSub: "Énergie infinie et zéro publicité"
      },
      rewardedAd: {
        connectAdMob: "Connexion AdMob en cours...",
        notSupported: "Bibliothèque non supportée dans cet environnement.",
        errorSdk: "Erreur d'initialisation du SDK : ",
        errorGeneric: "Erreur AdMob : ",
        expoSimulation: "Expo Go : Simulation Vidéo en cours...",
        expoHint: "(Attendez 2 secondes pour obtenir l'énergie)",
        webEndingIn: "La vidéo promotionnelle se terminera dans {time}s",
        webRewardIncoming: "Récompense à venir...",
        webPartnerTitle: "VinoLogic Partners",
        webPartnerSub: "Découvrez les meilleurs terroirs du monde.",
        webSponsoredBadge: "Annonce Sponsorisée",
        webCloseAction: "Fermer l'Annonce (Aucune Récompense)"
      }
    }
  }
};